import React, { useContext } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { ProfileContext } from '../../../contexts/profileContext';
import { Spinner } from '../../common';

export default function ButtonNext({ title, type, handler, className, loading = false, disabled }) {
  const [profile] = useContext(ProfileContext);
  const { masterOrganization: { customConfigurations: { colors } = {} } = {} } = profile;

  return (
    <button
      type={type}
      className={`btn btn-next p-4 flex flex-row gap-2 items-center justify-center text-white ${className} disabled:opacity-60`}
      style={{ backgroundColor: colors?.primary, borderRadius: colors?.buttonRadius }}
      onClick={handler}
      disabled={loading || disabled}>
      <span>{title}</span>
      <span className="icon-container ml-4">
        <FaArrowRight className="icon" />
      </span>
      <Spinner isSubmitting={loading} />
    </button>
  );
}

ButtonNext.defaultProps = {
  className: '',
  type: ''
};
